import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobileBotActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "2 0.5 12 11.25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 1C7.25 0.723858 7.47386 0.5 7.75 0.5H8.25C8.52614 0.5 8.75 0.723858 8.75 1V1.75H12.5C13.3284 1.75 14 2.42157 14 3.25V10.25C14 11.0784 13.3284 11.75 12.5 11.75H3.5C2.67157 11.75 2 11.0784 2 10.25V3.25C2 2.42157 2.67157 1.75 3.5 1.75H7.25V1Z",
			fill: "#2667FF",
			stroke: "#2667FF",
			strokeWidth: 1.25,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.5,
			cy: 6.5,
			r: 1.15,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 6.5,
			r: 1.15,
			fill: "white"
		})
	]
});
export default SvgMobileBotActive;
